import React from 'react';
import PropTypes from 'prop-types';
import './CompanyProfile.scss';
import { withTranslation } from 'react-i18next';
import { BiPlus, BiShareAlt } from "react-icons/bi";
import { Badge, Table } from 'react-bootstrap';
import Map from '../../../images/world-map.gif'
import { Chart } from "react-google-charts";

export const data = [
  ["Country", "Risk"],
  ["Germany", 200],
  ["United States", 300],
  ["Brazil", 400],
  ["Canada", 500],
  ["France", 600],
  ["RU", 700],
];

export const options = {
  // region: "002",
  colorAxis: { colors: ["#0a58ca", "#dddddd", "#0a58ca"] },
  backgroundColor: "#ffffff",
  datalessRegionColor: "#0a58ca",
  defaultColor: "#0a58ca",
};

const CompanyProfile = ({ t }) => {
  return (
    <div className="CompanyProfile">
      <div className='row m-0'>
        <div className='col-lg-4 p-2'>
          <div className='card mb-2'>
            <div className='card-body'>
              <ul className='Supplier_count02'>
                <li>
                  <strong>Supplier</strong> - Without answer
                </li>
                <li><strong>02</strong></li>
              </ul>
            </div>
          </div>

          <div className='card mb-2'>
            <div className='card-body'>
              <ul className='Supplier_count02'>
                <li>
                  <strong>High priority info</strong>
                </li>
                <li><strong>02</strong></li>
              </ul>
            </div>
          </div>

          <div className='card mb-2 SC-Risk02 5'>
            <div className='card-body p-0'>
              <div className='p-3'>
                <strong>Company Risk</strong>
              </div>
              <div className='main_SC-Risk02-view'>
                <ul>
                  <li>
                    <p>Risk category</p>
                    <h6 className='m-0 text-Medium'>Medium</h6>
                  </li>
                  <li>
                    <p>Risk rating</p>
                    <h6 className='m-0'>75/100</h6>
                  </li>
                </ul>
              </div>

              <div className='SC-Risk_parameterView02'>
                <div className='SC-RiskpView02_in'>
                  <ul>
                    <li>
                      <p className='m-0'> Risk parameters</p>
                    </li>
                    <li>
                      <p className='m-0'>(1-10)</p>
                    </li>
                  </ul>
                </div>
                <div className='SC-RiskpView02_in'>
                  <ul>
                    <li>
                      Material risk
                    </li>
                    <li>
                      <span className='bg-badge-Medium w-50'>5.4</span>
                    </li>
                  </ul>
                </div>
                <div className='SC-RiskpView02_in'>
                  <ul>
                    <li>
                      Supplier risk
                    </li>
                    <li>
                      <span className='bg-badge-High w-70'>6.9</span>
                    </li>
                  </ul>
                </div>
                <div className='SC-RiskpView02_in'>
                  <ul>
                    <li>
                      Human rights risk
                    </li>
                    <li>
                      <span className='bg-badge-Medium w-20'>2.4</span>
                    </li>
                  </ul>
                </div>
                <div className='SC-RiskpView02_in'>
                  <ul>
                    <li>
                      Environmental
                    </li>
                    <li>
                      <span className='bg-badge-Critical w-80'>8.2</span>
                    </li>
                  </ul>
                </div>
              </div>

            </div>
          </div>

          <div className='card mb-2 SC-Risk_forms02'>
            <div className='card-body'>
              <div className='SC-Risk_forms02-head'>
                <ul>
                  <li>
                    <strong>Forms</strong>
                  </li>
                  <li><button className='btn btn-blank_outline'><BiPlus /></button></li>
                </ul>
              </div>
              <div className='SC-Risk_forms02-body'>
                <ul>
                  <li>
                    <span>01</span> Shared to me
                  </li>
                  <li>
                    <span>04</span> Submmitted to me
                  </li>
                  <li>
                    <span>01</span> Expires this week
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className='card mb-2 SC-Risk_Documents02'>
            <div className='card-body'>
              <div className='SC-Risk_Documents02-head'>
                <strong>Documents</strong>
              </div>
              <div className='SC-Risk_Documents02-body'>
                <div className='Single_SC-Docu_02'>
                  <ul>
                    <li>Terms and conditions</li>
                    <li><button className='btn btn-blank_outline'><BiShareAlt /></button></li>
                  </ul>
                </div>
                <div className='Single_SC-Docu_02'>
                  <ul>
                    <li>Privacy policy</li>
                    <li><button className='btn btn-blank_outline'><BiShareAlt /></button></li>
                  </ul>
                </div>
                <div className='Single_SC-Docu_02'>
                  <ul>
                    <li>Disclaimer</li>
                    <li><button className='btn btn-blank_outline'><BiShareAlt /></button></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div className='col-lg-8 p-2'>
          <div className='card SC-Alert-Card02 mb-2 12'>
            <div className='SC-Alert-Card02-head'>
              <div className='SC-Alert-Card02-head_in'>
                <strong>Alert </strong>
                <span>03</span>
              </div>
            </div>
            <div className='SC-Alert-Card02-body'>
              <div className='Single_Alert_view02'>
                <ul>
                  <li>Child labour</li>
                  <li>
                    <Badge bg="badge-High">High</Badge>
                  </li>
                  <li>July 06,2022</li>
                </ul>
              </div>
              <div className='Single_Alert_view02'>
                <ul>
                  <li>Waste disposal</li>
                  <li>
                    <Badge bg="badge-High">High</Badge>
                  </li>
                  <li>July 06,2022</li>
                </ul>
              </div>
              <div className='Single_Alert_view02'>
                <ul>
                  <li>Branch country</li>
                  <li>
                    <Badge bg="badge-Medium">Medium</Badge>
                  </li>
                  <li>July 06,2022</li>
                </ul>
              </div>

              <div className='Single_Alert_view02'>
                <ul>
                  <li>Child labour</li>
                  <li>
                    <Badge bg="badge-High">High</Badge>
                  </li>
                  <li>July 06,2022</li>
                </ul>
              </div>
              <div className='Single_Alert_view02'>
                <ul>
                  <li>Waste disposal</li>
                  <li>
                    <Badge bg="badge-High">High</Badge>
                  </li>
                  <li>July 06,2022</li>
                </ul>
              </div>
              <div className='Single_Alert_view02'>
                <ul>
                  <li>Branch country</li>
                  <li>
                    <Badge bg="badge-Medium">Medium</Badge>
                  </li>
                  <li>July 06,2022</li>
                </ul>
              </div>

            </div>

          </div>

          <div className='card SC-Supplier_totalCard_02'>
            <div className='SC-Supplier_totalCard_02-head'>
              <strong>Supplier </strong>
            </div>
            <div className='SC-Supplier_totalCard_02-body'>
              <div className='row m-0'>
                <div className='col-lg-7 p-0'>
                  <div className='Sc-Total_supplierBox02'>
                    <ul>
                      <li>
                        Total no.of suppliers
                      </li>
                      <li>
                        <strong>500</strong>
                      </li>
                    </ul>
                  </div>

                  <div className='Sc-Total_supplierBox_table02'>

                    <Table borderless>
                      <thead>
                        <tr>
                          <th rowSpan={2}>Risk Category</th>
                          <th colSpan={3} className="text-center">Risk Parameter</th>
                        </tr>
                        <tr>
                          <th>Overall</th>
                          <th>Human Rights</th>
                          <th>Environmental</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Critical</td>
                          <td className='text-red'>100</td>
                          <td className='text-red'>100</td>
                          <td className='text-red'>100</td>
                        </tr>
                        <tr>
                          <td>Very High</td>
                          <td>100</td>
                          <td>100</td>
                          <td>100</td>
                        </tr>
                        <tr>
                          <td>High</td>
                          <td>100</td>
                          <td>100</td>
                          <td>100</td>
                        </tr>
                        <tr>
                          <td>Moderate</td>
                          <td>100</td>
                          <td>100</td>
                          <td>100</td>
                        </tr>
                        <tr>
                          <td>Moderate to low</td>
                          <td>100</td>
                          <td>100</td>
                          <td>100</td>
                        </tr>
                        <tr>
                          <td>Very Low</td>
                          <td>100</td>
                          <td>100</td>
                          <td>100</td>
                        </tr>
                        <tr>
                          <td>Low</td>
                          <td>100</td>
                          <td>100</td>
                          <td>100</td>
                        </tr>
                      </tbody>
                    </Table>

                  </div>

                </div>
                <div className='col-lg-5 p-3'>
                  <div className='text-end mb-2'>
                    <p className='m-0'>Most report case</p>
                    <strong>Child labour</strong>
                  </div>
                  <div className='text-end mb-2'>
                    <p className='m-0'>Most report country</p>
                    <strong>Afganistan</strong>
                  </div>
                  <div className='text-end mb-2'>
                    <p className='m-0'>Country of maximum high risk supplier</p>
                    <strong>Ukraine</strong>
                  </div>
                </div>


                <div className='col-lg-12 p-0'>
                  {/* <img src={Map} className=""/> */}
                  <Chart
                    chartEvents={[
                      {
                        eventName: "select",
                        callback: ({ chartWrapper }) => {
                          const chart = chartWrapper.getChart();
                          const selection = chart.getSelection();
                          if (selection.length === 0) return;
                          const region = data[selection[0].row + 1];
                          console.log("Selected : " + region);
                        },
                      },
                    ]}
                    chartType="GeoChart"
                    width="100%"
                    height="400px"
                    data={data}
                    options={options}
                  />
                </div>

              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  );
};
export default withTranslation()(CompanyProfile);

